export default __webpack_public_path__ + "static/media/gerb.2fe8ed77.jpg";